export default "__VITE_ASSET__DvM2Uybv__"